export default {
  // 강의 시작
  START_LECTURE: state => {
    state.isShareContents = true

    console.log('강의 시작')
  }
}
